var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { toFen } from '../../../utils/unit-conversion';
import cookie from '../../../cookie/cookie';
import { mapState } from 'vuex';
export default Vue.extend({
    data: function () {
        return {
            userName: '',
            applyForm: {},
            error: false,
            applyRules: {
                loanAmount: [
                    { required: true, message: '借款金额不能为空', trigger: 'blur' },
                    { validator: this.checkInteger, trigger: 'blur' },
                ],
            },
        };
    },
    created: function () {
        this.$emit('to-loan-launch', {
            status: 1,
            stepActive: 0,
        });
        this.getUserName();
    },
    computed: __assign({}, mapState('loan', ['customer'])),
    methods: {
        getUserName: function () {
            this.userName = cookie.getCookie('usernameZh');
        },
        checkInteger: function (rule, value, callback) {
            var res = /^\s*\d+0{2}\s*$/;
            if (!value) {
                return callback(new Error('请输入100的倍数'));
            }
            else if (!res.test(value)) {
                return callback(new Error('请输入100的倍数'));
            }
            else if (Number(value) < 30000) {
                return callback(new Error('借款最低金额3万元'));
            }
            else {
                callback();
            }
        },
        submitApply: function () {
            var _this = this;
            this.$refs['applyForm'].validate(function (valid) {
                if (!valid) {
                    return;
                }
                var loanAmount = toFen(_this.applyForm.loanAmount);
                var userName = _this.userName;
                _this.$request({
                    method: 'post',
                    url: '/proxy/oneCar/api/loan/amount/apply',
                    data: {
                        loanAmount: loanAmount,
                        tenantName: userName,
                        remark: '',
                    },
                }).then(function (res) {
                    if (!res)
                        return;
                    if (res && !res.errorCode) {
                        var loanOrderId = res.data.loanOrderId;
                        if (loanOrderId) {
                            _this.$router.push({
                                name: 'orangeLoanApplyStatus',
                                query: {
                                    loanOrderId: loanOrderId,
                                },
                            });
                            return;
                        }
                        // 如果保证金不足
                        _this.$confirm('', '', {
                            message: "<p class=\"title\">\u4FDD\u8BC1\u91D1\u4F59\u989D\u4E0D\u8DB3</p><p class=\"text\">\u8BF7\u8054\u7CFB\u5BA2\u6237\u7ECF\u7406\u8FDB\u884C\u8865\u7F34\uFF0C\u5F85\u7F34\u7EB3\u7684\u4FDD\u8BC1\u91D1\u751F\u6548\u540E\u60A8\u53EF\u91CD\u65B0\u53D1\u8D77\u7533\u8BF7\u3002</p><p style='color:#858B9C;font-size:12px'>\u60A8\u53EF\u5728\u501F\u6B3E-\u4FDD\u8BC1\u91D1\u5361\u7247\u4E2D\u67E5\u770B\u4FDD\u8BC1\u91D1\u4FE1\u606F</p>",
                            dangerouslyUseHTMLString: true,
                            distinguishCancelAndClose: false,
                            showClose: false,
                            confirmButtonText: '知道了',
                            type: 'warning',
                        }).then(function () { });
                    }
                });
            });
        },
        closeCurrent: function () {
            this.$emit('to-loan-launch', {
                status: 0,
                stepActive: 0,
            });
            this.$router.push({ name: 'orangeLoanOrderList' });
        },
    },
});
